import { Menu } from '@pocketlaw/tetris';
import { useField } from 'formik';
import { useSelectField } from './SelectFieldContext';
export function Option(props) {
    const { children, value } = props;
    const { name } = useSelectField();
    const [field, , helpers] = useField(name);
    const isSelected = field.value === value;
    const handleOnClick = () => {
        helpers.setValue(value);
        helpers.setTouched(true);
    };
    return (<Menu.Item selected={isSelected} onClick={handleOnClick}>
      {children}
    </Menu.Item>);
}
